module.exports = __webpack_public_path__ + "static/footer-bg-813eb446272e3d3688052845d81962fe.png";